/**
 * Used to prevent storing / passing raw password during sign-up & on-boarding.
 * No password is stored on the client exists only inside the signed token.
 * Stores only the opaque onboarding token — no pwd ever stored here
 * Cleared on refresh/unload to prevent persistence.
 * Short-lived token (30 minutes)
 */

let _onboardingToken: string | null = null;
let _role: string | null = null;
let _email: string | null = null;

export function setOnboardingToken(token: string, role: string, email: string) {
  _onboardingToken = token;
  _role = role;
  _email = email;
}

export function getOnboardingToken(): string | null {
  return _onboardingToken;
}

export function getSignupRole(): string | null {
  return _role;
}

export function getUserEmail(): string | null {
  return _email;
}

export function clearOnboardingToken() {
  _onboardingToken = null;
  _role = null;
  _email = null;
}
